<template>
  <v-layout column align-center justify-center mt-5>
    <v-slide-x-transition key = '0' v-show = 'Object.keys($store.getters.favReports).length == 0 && Object.keys(this.$store.getters.recentReports).length == 0'>
      <v-container fluid class='py-0 mb-2' v-if = 'Object.keys(this.$store.getters.favReports).length == 0 && Object.keys(this.$store.getters.recentReports).length == 0'>
        <v-layout d-flex column wrap class = 'my-2 pa-4 title font-weight-light' style = 'width: 75%; margin: auto; box-shadow: 0px 0px 30px 2px rgba(217,217,217,0.5); border-radius: 4px; background: white;'>
          <span>Добро пожаловать, {{$store.getters.currentUser.name}}!</span>
          <span v-if = '!$store.getters.currentUser.mode_projects'>Похоже, что вам еще не предоставили доступ к каким-либо отчетам.</span>
          <span v-else>Похоже, что вы еще не добавили свои проекты в систему. Сделать это можно через выпадающее меню в шапке сайта.</span>
        </v-layout>
      </v-container>
    </v-slide-x-transition>
    <v-layout style = 'position: absolute; top: 0; right: 0;'>
      <v-menu
        left
        transition = 'slide-x-transition'
        offset-y
        :close-on-content-click = 'false'
        :max-width = '$vuetify.breakpoint.smAndUp? "50%": "100%"'
        style = 'overflow: hidden;'
      >
        <template v-slot:activator = '{ on }'>
           <v-btn
            fab
            x-small
            v-on = 'on'
            :color = '!$vuetify.theme.dark? `white`:`grey darken-3`'
            :class = '`mt-${$vuetify.breakpoint.smAndUp?"6":"1"} mr-4`'
            :style = '`box-shadow: 0px 0px 30px 2px ${$store.getters.appTheme.shadow} !important; overflow: hidden;`'
          >
            <v-icon small :color = '$store.getters.uiAccent'>mdi-filter</v-icon>
          </v-btn>
        </template>
        <v-card flat style = 'border-radius: 4px;' min-width = "280px" max-width="320px">
          <v-layout column class = 'py-3 px-1'>
            <v-layout align-start class = 'font-weight-light'>
              <span class = 'body-2 pr-1 pl-4 my-1' style = 'min-width: 100px;'>Вертикаль</span>
              <v-chip-group v-model = 'selection.vertical' column multiple>
                <v-chip 
                  outlined small
                  v-for = 's in availableVerticals'
                  :color = 'selection.vertical.includes(s) ? $store.getters.uiAccent: ""'
                  :key = 's' :value = 's' class = 'mx-0 mr-1 my-0 mb-1'
                >{{s}}</v-chip>
              </v-chip-group>    
            </v-layout>
            <v-divider class = 'my-1'></v-divider>
            <v-layout align-start class = 'font-weight-light'>
              <span class = 'body-2 pr-1 pl-4 my-1' style = 'min-width: 100px;'>Сегмент</span>
              <v-chip-group v-model = 'selection.segment' column multiple>
                <v-chip 
                  outlined small
                  v-for = 's in availableSegments'
                  :color = 'selection.segment.includes(s) ? $store.getters.uiAccent: ""'
                  :key = 's' :value = 's' class = 'mx-0 mr-1 my-0 mb-1'
                >{{s}}</v-chip>
              </v-chip-group>    
            </v-layout>
            <v-divider class = 'my-1'></v-divider>
            <v-row align='center'>
              <v-col>
                <v-btn x-small text @click = 'selection.archive_projects = !selection.archive_projects'>
                  <template v-if = '!selection.archive_projects'>
                    <v-icon small left>mdi-package-down</v-icon>Архив проектов
                  </template>
                  <template v-else>
                    <v-icon small left>mdi-package-up</v-icon>Активные проекты
                  </template>
                </v-btn>
              </v-col>
              <v-col>
                <v-switch class = 'my-auto ml-auto' v-model = 'selection.archive_reports' hide-details>
                  <template v-slot:label>
                    <span class = 'caption font-weight-light'>Показать архивные отчеты</span>
                  </template>
                </v-switch>
              </v-col>
            </v-row>
          </v-layout>
        </v-card>
      </v-menu>
    </v-layout>
    <v-slide-x-transition key = '1' v-show = 'Object.keys(filteredFavorites).length > 0' hide-on-leave>
      <v-container fluid :class = '`py-0 mb-2 ${$vuetify.breakpoint.smAndUp? "":"mt-6"}`' v-if = 'Object.keys(filteredFavorites).length > 0'>
        <v-layout d-flex row wrap class = 'my-1' v-bind:style = '"width: " + ($vuetify.breakpoint.smAndUp? 75: 100 ) + "%; margin: auto;"'>
          <v-list :style = '`width: 100%; box-shadow: 0px 0px 30px 2px ${$store.getters.appTheme.shadow}; border-radius: 4px;`' class = 'pt-0'>
            <v-subheader>
              <span :class = '`font-weight-regular ${!$vuetify.theme.dark? "black--text":""}`' style = 'font-size: 18px; user-select: none;'>Избранное</span>
              <v-icon class = 'ml-auto' :color = '$store.getters.uiAccent'>mdi-star-outline</v-icon>
            </v-subheader>
            <v-divider :color = '$store.getters.uiAccent'></v-divider>
            <o-group :groups = 'filteredFavorites' @requestUpdateReportsList = 'getReports'></o-group>
          </v-list>
        </v-layout>
      </v-container>
    </v-slide-x-transition>
    <v-slide-x-transition key = '2' v-show = 'Object.keys(filteredAll).length > 0' mode = 'out-in' hide-on-leave>
      <v-container fluid class='py-0 mb-2' v-if = 'Object.keys(filteredAll).length > 0'>
        <v-layout d-flex row wrap class = 'my-1' v-bind:style = '"width: " + ($vuetify.breakpoint.smAndUp? 75: 100 ) + "%; margin: auto;"'>
          <v-list :style = '`width: 100%; box-shadow: 0px 0px 30px 2px ${$store.getters.appTheme.shadow}; border-radius: 4px; overflow:hidden;`' class = 'pa-0'>
            <v-list-group class = 'pt-0' no-action append-icon = ''>
              <template v-slot:activator>
                <v-subheader style = 'width: 100%;' class = 'pa-0'>
                  <span :class = '`font-weight-regular ${!$vuetify.theme.dark? "black--text":""}`' style = 'font-size: 18px; user-select: none;'>Доступные отчеты</span>
                  <v-icon class = 'ml-auto' :color = '$store.getters.uiAccent'>mdi-history</v-icon>
                </v-subheader>
              </template>
              <template>
                    <v-list class = 'ma-0 pa-0'>
                      <v-divider :color = '$store.getters.uiAccent' class = 'my-0'></v-divider>
                      <o-group :groups = 'filteredAll' @requestUpdateReportsList = 'getReports'></o-group>
                    </v-list>
              </template>
            </v-list-group>
          </v-list>
        </v-layout>
      </v-container>
    </v-slide-x-transition>
    <!--v-btn 
      fab absolute bottom right 
      @click = 'dialogs.notes = true;'
      class = 'my-10'
    >
      <v-icon>mdi-calendar-text-outline</v-icon>
    </v-btn!-->
  </v-layout>
</template>

<script>

  import ObjectsListGroup from '@/components/elements/groups/ObjectsListGroup.vue'
  import { orderBy } from 'lodash-es'
  import dayjs from 'dayjs'

  export default {
    components: {
      'o-group': ObjectsListGroup
    },
    data() {
      return {
        indicator: false,
        cursorReport: {},
        selection: {
          segment: [],
          vertical: [],
          archive_projects: false,
          archive_reports: false
        },
        dialogs: {
          notes: false
        },
        visibility: {
          check: true,
          update: false,
          delete: false
        }
      }
    },
    computed: {
      availableSegments() {
        return Array.from(
          new Set(
            this.$store.getters.userObjects
              .filter((o) => !this.selection.vertical || !this.selection.vertical.length || this.selection.vertical.includes(o.vertical))
              .map( o => o.segment )
          )
        )
      },
      availableVerticals() {
        return Array.from(
          new Set(
            this.$store.getters.userObjects
              .filter((o) =>  !this.selection.segment || !this.selection.segment.length || this.selection.segment.includes(o.segment))
              .map( o => o.vertical )
            )
          )
      },
      filteredFavorites() {
        let all = this.$store.getters.favReports
          .filter( (o) => o.active != this.selection.archive_projects)
          .filter((o) =>  !this.selection.segment || !this.selection.segment.length || this.selection.segment.includes(o.segment))
          .filter((o) => !this.selection.vertical || !this.selection.vertical.length || this.selection.vertical.includes(o.vertical))
        if (!this.selection.archive_reports) {
            all = all.map( (o) => ({...o, 'reports': o.reports.filter( (r) => r.active != 0)}))
        }
        return orderBy(all || [], 'project_name', 'asc');
      },
      filteredAll() {
        let all = this.$store.getters.recentReports
          .filter( (o) => o.active != this.selection.archive_projects)
          .filter((o) => !this.selection.segment || !this.selection.segment.length || this.selection.segment.includes(o.segment))
          .filter((o) => !this.selection.vertical || !this.selection.vertical.length || this.selection.vertical.includes(o.vertical))
        if (!this.selection.archive_reports) {
            all = all.map( (o) => ({...o, 'reports': o.reports.filter( (r) => r.active != 0)}))
        }
        return orderBy(all || [], 'project_name', 'asc');
      }
    },
    watch: {
      selection: {
        deep: true,
        handler(value) {
          if (value && value.archive_projects) {
            this.$dataLayer.$emit('enrich', {
              event: 'interaction',
              data: {
                type: 'change_view',
                target: 'archive'
              },
              once: true
            })
          }
        }
      }
    },
    methods: {
      toggleCheckbox() {
        if (this.visibility.check) {
          confirm('Are you sure?')? this.visibility.check = false: this.visibility.check = true;
        }
      },
      getReports() {
        this.indicator = true;
        this.$http.get(this.$store.getters.endpoint + '/db/reports', {
            emulateJSON: true,
            params: {'login': this.$store.getters.userLogin},
            headers: this.$store.state.restrictedHeaders
          }).then( (r) => {
            let response = r.body;
            if (response.result) {
              this.indicator = false;
              this.$store.commit('updateUserReports', response.data)
            } else {
              console.log(response)
            }
          })
      }
    },
    mounted() {
      this.$root.$on('confirmNotesDialogVisibility', (v) => {
        this.dialogs.notes = v;
      })
    },
    beforeRouteEnter (to,from,next) {
      next(vm => {
        vm.$store.commit('setBreadcrumbs', {text: 'Главная', disabled: true, href: '/'})
      });
    }
  };
</script>
